/**
 * CLS-SE specific legal copy (Swedish) for Terms & Conditions and Privacy Policy.
 * Overrides the shared (Danish) content in Clothing/Common/HelpCenter/legalContent.js.
 */

export const PRIVACY_TITLE = 'Personuppgiftspolicy';

export const PRIVACY_SECTIONS = [
  {
    blocks: [
      {
        type: 'p',
        text: 'C.L. Seifert Sverige AB (”vi”, ”oss”) tar seriöst på den personliga integriteten hos alla våra kunder (”dig”, ”dina”). Vi är måna om att din rättigheter respekteras och att dina personuppgifter behandlas korrekt och i enlighet med gällande dataskyddslagstiftning, däribland Europaparlamentets och rådets förordning (EU) 2016/679 (Dataskyddsförordningen (GDPR)), Lag (2018:218) med kompletterande bestämmelser till EU:s dataskyddsförordning (Dataskyddslagen) samt Lag (2003:389) om elektronisk kommunikation.',
      },
      {
        type: 'p',
        text: 'Syftet med denna personuppgiftspolicy är att på ett tydligt och transparent beskriva hur och varför vi behandlar dina personuppgifter samt vilka rättigheter du har.',
      },
    ],
  },
  {
    title: 'Definitioner',
    blocks: [
      {
        type: 'p',
        text: 'Med personuppgifter avses varje upplysning som direkt eller indirekt går att härleda till en person, såsom namn, personnummer m.m.',
      },
      {
        type: 'p',
        text: 'Med behandling avses all typ av åtgärd beträffande personuppgifter, såsom insamling, registrering, organisering, strukturering, lagring, bearbetning eller ändring, framtagning, läsning, användning, utlämning genom överföring, spridning eller tillhandahållande på annat sätt, justering eller sammanförande, begräsning, radering eller förstöring.',
      },
    ],
  },
  {
    title: 'Personuppgiftsansvarig',
    blocks: [
      {
        type: 'lines',
        lines: [
          'C.L. Seifert Sverige AB, org.nr.: 556752-8285',
          'Adress: Box 24262, 104 51 Stockholm, Sverige',
          'Telefonnummer: 031 – 308 80 70',
          'E-postadress: info@clseifert.se',
        ],
      },
      {
        type: 'p',
        text: 'Vid frågor kring vår hantering av personuppgifter kontakta vår kundtjänst.',
      },
    ],
  },
  {
    title: 'Vilka personuppgifter samlar vi in från dig?',
    blocks: [
      { type: 'p', text: 'När du anmäler dig via vår hemsida sparar vi följande uppgifter om dig:' },
      {
        type: 'ul',
        items: ['Skola och klassnamn', 'För- och efternamn', 'Telefonnummer', 'E-postadress', 'Adress'],
      },
    ],
  },
  {
    title: 'Syftet med, och de legala grunderna för, vår behandling av dina personuppgifter',
    blocks: [
      {
        type: 'p',
        text: 'Vi behandlar dina personuppgifter dels i syfte att kunna fullfölja vårt avtal med dig och dels utifrån vårt berättigade intresse av att kunna kommunicera med dig. Vi använder oss endast av de personuppgifter du meddelat oss i enlighet med gällande dataskyddslagstiftning.',
      },
      {
        type: 'p',
        text: 'Personuppgifter som du lämnar via hemsidan används för att kunna hantera din beställning, fakturering, leverans och marknadsföringsåtgärder. Kommunikation kan ske via brev, e-post eller SMS.',
      },
    ],
  },
  {
    title: 'Marknadsföring',
    blocks: [
      {
        type: 'p',
        text: 'När du registrerar dig för vårt nyhetsbrev eller skapar ett konto kan vi med ditt godkännande även använda din e-postadress och telefonnummer i syfte att kunna skicka ut reklam och marknadsundersökningar. Marknadsförings- och nyhetsutskick relaterade till tidigare beställningar vilar på vårt berättigade intresse och du kan när som helst avbryta utskicken genom att antingen avsluta prenumerationen via e-post eller genom att ta bort ditt konto.',
      },
    ],
  },
  {
    title: 'Rättslig skyldighet',
    blocks: [
      {
        type: 'p',
        text: 'Vi kan ha en rättslig skyldighet att spara vissa av de personuppgifter vi har om dig enligt tillämplig lagstiftning, exempelvis Bokföringslagen (SFS 1999:1078).',
      },
    ],
  },
  {
    title: 'Cookies',
    blocks: [
      {
        type: 'p',
        text: 'Webbplatsen använder “cookies”, som är en textfil som lagras på din dator, mobil eller mobil. Denna fil används för att komma ihåg inställningar, utföra statistik och rikta in annonser. Cookies kan inte innehålla skadlig kod, t.ex. virus.',
      },
      {
        type: 'p',
        text: 'När du besöker vår webbplats samlas information om dig som används för att anpassa och förbättra innehållet och öka värdet av våra annonser på Facebook etc. Om du inte vill samla information ska du ta bort dina cookies och undvika ytterligare användning av webbplatsen. Det är möjligt att radera eller blockera cookies. Se guiden: http://minecookies.org/cookiehandtering. Nedan har vi utarbetat vilken information som samlas in, deras syfte och vilka tredje parter som har tillgång till dem.',
      },
      {
        type: 'p',
        text: 'Om du tar bort eller blockerar cookies kan du riskera att webbplatsen inte fungerar korrekt och att det finns innehåll som du inte kan komma åt.',
      },
      { type: 'p', text: 'Webbplatsen innehåller cookies från tredje part som kan variera till en viss grad:' },
      { type: 'ul', items: ['Google', 'META', 'Hotjar'] },
      {
        type: 'p',
        text: 'Vi samlar och bearbetar vanligtvis följande typer av information: Ett unikt ID och teknisk information om din dator, surfplatta eller mobiltelefon, ditt IP-nummer, geografisk plats och vilka sidor du klickar på (intressen). I den utsträckning du uttryckligen samtycker till detta och godkänner informationen kommer vi också att behandlas: Namn, telefonnummer, e-postadress, adress och betalningsinformation. Detta kommer normalt att vara kopplat till skapandet av inloggning eller inköp på webbplatsen.',
      },
      {
        type: 'p',
        text: 'Data om din användning av webbplatsen, vilka annonser du nås av, klick på webbplatsen, geografiskt läge, kön och ålderssegment etc. lämnas ut till tredje part i den mån denna information är känd. Informationen används för att samla in statistik samt för att förbättra webbplatsen.',
      },
      {
        type: 'p',
        text: 'Dessutom använder vi ett antal tredje parter för att lagra och bearbeta delar av data. Dessa hanterar endast data och information på vår vägnar och får inte användas för tredje parts egna ändamål.',
      },
    ],
  },
  {
    title: 'Mottagare av personuppgifter',
    blocks: [
      {
        type: 'p',
        text: 'Mottagare av dina personuppgifter kan vara vårt eget bolag, våra systerbolag (som ingår i samma koncern) samt någon av våra samarbetspartners för betalning och leverans för att genomföra mellan oss överenskomna avtal. Behandling av vissa uppgifter kan således ske hos någon av våra samarbetspartners och systerbolag i den mån sådana är engagerade för fullgörandet av avtalet mellan dig som kund och bolaget. Vi kan även få tillgång till dina personuppgifter från någon av ovan angivna parter utan att du direkt har givit dem till oss.',
      },
    ],
  },
  {
    title: 'Hur länge sparas dina personuppgifter?',
    blocks: [
      {
        type: 'p',
        text: 'Dina personuppgifter sparas inte längre än nödvändigt med hänsyn till ovan angivna ändamål och vi raderar alltid dina personuppgifter när det inte längre finns en legal grund att behålla dem. Personuppgifter som du har angett kommer som regel att sparas så länge du har ditt konto hos oss. Din e-postadress och telefonnummer kan komma att sparas under en tid efter att du har avslutat ditt konto för nyhetsutskick och marknadsföring under förutsättning att du har godkänt detta.',
      },
    ],
  },
  {
    title: 'Säkerhet',
    blocks: [
      {
        type: 'p',
        text: 'Vi behandlar de personuppgifter som är anförtrodda oss på ett säkert sätt. Skydd finns mot intrång och förstörelse av personuppgifter och vi vidtar kontinuerligt tekniska och organisatoriska åtgärder för att minska riskerna med detta.',
      },
    ],
  },
  {
    title: 'Vilka är dina rättigheter?',
    blocks: [
      {
        type: 'p',
        text: 'Som registrerad har du en mängd rättigheter avseende dina personuppgifter enligt tillämplig dataskyddslagstiftning. Dessa är mer utförligt förklarade i GDPR och inkluderar din rätt:',
      },
      {
        type: 'ul',
        items: [
          'att av personuppgiftsansvarige begära tillgång till dina personuppgifter,',
          'att begära rättelse eller radering av personuppgifter,',
          'att i vissa fall begära begränsning av behandling som rör dig,',
          'att invända mot behandling, samt',
          'till dataportabilitet. Rätten till dataportabilitet innebär att du i vissa fall har rätt att få ut och använda dina personuppgifter på annat håll.',
        ],
      },
    ],
  },
  {
    title: 'Frågor',
    blocks: [
      {
        type: 'p',
        text: 'Om du har några frågor eller vi utöva någon av dina rättigheter avseende dina personuppgifter kan du alltid kontakta oss på info@clseifert.se.',
      },
    ],
  },
  {
    title: 'Klagomål',
    blocks: [
      {
        type: 'p',
        text: 'Du har alltid rätt att inge eventuella klagomål till Datainspektionen. Ytterligare information finns på Datainspektionens webbplats, www.datainspektionen.se',
      },
    ],
  },
  {
    title: 'Skydd mot skräppost (CAPTCHA)',
    blocks: [
      {
        type: 'p',
        text: 'För att skydda våra formulär (t.ex. kontaktformuläret) mot skräppost och missbruk använder vi Cloudflare Turnstile. När Turnstile körs i osynligt läge behandlar Cloudflare viss teknisk information om din enhet och webbläsare. Läs mer i Cloudflares integritetstillägg för Turnstile: https://www.cloudflare.com/en-gb/turnstile-privacy-policy/',
      },
    ],
  },
  {
    title: 'AI-assistent i vår administration (Anthropic)',
    blocks: [
      {
        type: 'p',
        text: 'Våra medarbetare kan använda en AI-assistent i vårt interna administrationssystem, till exempel när de besvarar frågor om beställningar, produkter och skolbutiker. Assistenten levereras av Anthropic (Claude). När en medarbetare ställer en fråga som kräver det kan uppgifter från din beställning skickas till Anthropic: namn, kontaktuppgifter, leveransadress, skola och klass, födelsedatum (ålder) samt beställningens innehåll, betalnings- och leveransstatus. Ditt personnummer skickas aldrig till Anthropic. Assistenten har bara tillgång till de uppgifter som medarbetaren själv har behörighet till.',
      },
      {
        type: 'p',
        text: 'Anthropic behandlar uppgifterna som personuppgiftsbiträde för vår räkning och får inte använda dem för egna ändamål, till exempel för att träna AI-modeller. Uppgifterna behandlas i USA; överföringen sker med stöd av EU-kommissionens standardavtalsklausuler i vårt personuppgiftsbiträdesavtal med Anthropic. Den rättsliga grunden är vårt berättigade intresse av att kunna ge snabb och korrekt kundservice och administration (artikel 6.1 f i dataskyddsförordningen). Läs mer i Anthropics integritetspolicy: https://www.anthropic.com/legal/privacy',
      },
    ],
  },
];

export const TERMS_TITLE = 'Köpvillkor';

export const TERMS_SECTIONS = [
  {
    blocks: [
      {
        type: 'p',
        text: 'Nedan finner du de köpvillkor och det avtal som gäller vid beställning och köp av produkter ur vårt sortiment. Till exempel beskrivs hur och när du ska betala och hur vi kan hjälpa dig om något blir fel.',
      },
    ],
  },
  {
    title: 'Varan',
    blocks: [
      {
        type: 'p',
        text: 'C.L. Seifert reserverar sig för eventuella tryckfel. Vi kan inte heller garantera att alla bilder exakt återger produktens verkliga utseende. Vid varor med personlig prägel såsom brodyr eller namntryck förbehåller sig C.L. Seifert rätten att häva ett köp om texten är stötande.',
      },
      {
        type: 'p',
        text: 'Kunden har haft möjlighet att testa varan genom det varuprov som C.L. Seifert tillhandahållit. Kunden har därmed godkänt varans utförande och beskaffenhet.',
      },
    ],
  },
  {
    title: 'Tillämplighet',
    blocks: [
      {
        type: 'p',
        text: 'Dessa villkor gäller för avtal om köp av varor ur den studentkollektion som C.L. Seifert Sverige AB (Org.nr. 556752-8285) erbjuder vid köptillfället.',
      },
    ],
  },
  {
    title: 'Avtalets ingående',
    blocks: [
      {
        type: 'p',
        text: 'Varor beställs på det sätt som C.L. Seifert anvisar. Har inget annat avtalats skriftligen skall avtal anses ingånget när kunden gjort sin beställning och den accepterats av C.L. Seifert. Vid beställning av personer under 18 år krävs i de flesta fall godkännande från målsman. Om en person över 16 år tjänat pengar genom eget arbete eller fått pengar som gåva kan avtal som rör dessa medel ingås utan målsmans godkännande. Beställningar från personer under 16 år behandlas endast med målsmans samtycke.',
      },
    ],
  },
  {
    title: 'Beställning och orderbekräftelse',
    blocks: [
      {
        type: 'p',
        text: 'När vi mottagit din beställning skickar vi dig en orderbekräftelse via e-post med information om din beställning. Ni mottager även en förenklad bekräftelse i SMS-format. Kontrollera alltid din orderbekräftelse så att allt stämmer. Skulle det vara något du undrar över så kontakta vår kundtjänst. Det är bra om du sparar orderbekräftelsen för att ha denna till hands vid eventuella kontakter med kundtjänst. När du kontaktar oss är det bra om du har ordernummer tillhanda. Vill du annullera eller ändra något i din order så kan du själv göra det genom att logga in på ”Mina sidor” eller kontakta kundtjänst inom 14 dagar att mössutprovning ägt rum på din skola.',
      },
    ],
  },
  {
    title: 'Avbeställning och ångerrätt',
    blocks: [
      { type: 'h4', text: 'Om ångerrätt' },
      {
        type: 'p',
        text: 'Enligt svensk lag om distansavtal och avtal utanför affärslokaler (2005:59) har du 14 dagars ångerrätt från det att du tog emot varan eller en väsentlig del av den (du har tagit varan i fysisk besittning). Du har rätt att ångra din beställning utan att ange skäl eller bli debiterad några avgifter för avbeställningen. C.L. Seifert återbetalar dock inte extra leveranskostnader till följd av att du valt något annat leveranssätt än den billigaste standardleverans vi erbjuder. Distansavtalslagens bestämmelser om ångerrätt gäller dock inte för varor som är specialtillverkade eller har en tydligt personlig prägel.',
      },
      {
        type: 'p',
        text: 'För rätt till full återbetalning av erlagt belopp är du skyldig att lämna eller sända tillbaka mottagna varor på egen bekostnad. Vi får vänta med återbetalningen tills vi fått tillbaka varan från dig eller tills du sänt in ett bevis på att du återsänt varan, beroende på vilket som inträffar först.',
      },
      {
        type: 'p',
        text: 'Varan ska återsändas senast 14 dagar från och med den dag vi mottog ditt skriftliga meddelande (via fax, post eller e-post) om att du önskar ångra avtalet. Varan ska alltid skickas tillbaka i originalskick, vilket innebär att den inte får vara använd eller skadad. Skicka alltid tillbaka varan i originalförpackningar med emballage.',
      },
      {
        type: 'p',
        text: 'Meddelande om att du vill nyttja din ångerrätt kan med fördel göras via mail. Använd följande e-mail: info@clseifert.se',
      },
      { type: 'h4', text: 'Om ångerrätt av specialtillverkade varor/varor med tydlig personlig prägel' },
      {
        type: 'p',
        text: 'Din ångerrätt gäller under 14 dagar i enlighet med Distansavtalslagen. Ångerfristen börjar löpa den dag du tog emot varan eller en väsentlig del av den. Om köpet gäller en specialtillverkad vara eller en vara som fått en tydlig personlig prägel, börjar ångerfristen löpa den dag vi lämnat information till dig via orderbekräftelse, vanligen tillsänd via e-mail samt SMS.',
      },
      {
        type: 'p',
        text: 'Meddelande om att du vill returnera varan måste göras via mejl. Använd följande e-mail: info@clseifert.se',
      },
      {
        type: 'p',
        text: 'För rätt till full återbetalning av erlagt belopp är du skyldig att lämna eller sända tillbaka eventuellt mottagna varor på egen bekostnad. Vi får vänta med återbetalningen tills vi fått tillbaka varan från dig eller tills du sänt in ett bevis på att du återsänt varan, beroende på vilket som inträffar först. Varan ska återsändas till C.L. Seifert senast 14 dagar från och med den dag varan har levererats till dig/till den plats du beställt avhämtning på (varan är tillgänglig för dig). Varan ska alltid skickas tillbaka i originalskick, vilket innebär att den inte får vara använd eller skadad. Skicka alltid tillbaka varan i originalförpackningar med emballage.',
      },
    ],
  },
  {
    title: 'Faktureringsvillkor',
    blocks: [
      {
        type: 'p',
        text: 'Fakturering sker till av kunden angiven adress eller på sätt som överenskommits skriftligen mellan kunden och C.L. Seifert. Kunden är medveten om att faktura kan komma att adresseras till målsman för kunden. Vid kundfaktura äger C.L. Seifert rätt att utta expeditionsavgift. Kunden är medveten om att vissa produkter kan komma att faktureras separat från övriga produkter.',
      },
      {
        type: 'p',
        text: 'Vi bryr oss om din ekonomiska trygghet och vill hjälpa dig undvika överskuldsättning. Vi erbjuder en mängd alternativ i olika prisklasser och uppmuntrar dig att aldrig handla för mer än du har råd med. Som tidigare angetts ska betalning vara oss tillhanda senast 30 dagar efter fakturadatum. Ibland önskar man som kund betala senare än så men för att du inte ska lockas att handla över din budget kommer vi, för order som faktureras efter leverans, aldrig förlänga kredittiden utan du har 30 dagar på dig att betala.',
      },
    ],
  },
  {
    title: 'Pris- och betalningsvillkor',
    blocks: [
      {
        type: 'p',
        text: 'Pris följer av C.L. Seifert:s vid var tid gällande prislista och anges inklusive mervärdesskatt samt andra enligt lag tillkommande skatter. Förskottsbetalning gäller om ej annat angivits vid beställningstillfället. Betalning skall vara C.L. Seifert tillhanda senast 30 dagar efter fakturadatum. Är inte betalning fullgjord senast på förfallodagen utgår dröjsmålsränta enligt lag. C.L. Seifert äger rätt att ta ut ersättning för skriftlig betalningspåminnelse samt för lagstadgade inkassokostnader. Betalning sker på det sätt som C.L. Seifert anvisar. Vid försenad betalning äger C.L. Seifert ingen skyldighet att leverera beställda varor. Kunden är medveten om att fakturan kan komma att administreras av tredje part.',
      },
    ],
  },
  {
    title: 'Priser',
    blocks: [
      {
        type: 'p',
        text: 'Samtliga varor anges med pris inklusive moms. I kundvagnen kan man se det totala priset inklusive alla avgifter, moms, frakt och betalning.',
      },
    ],
  },
  {
    title: 'Etiska regler och rätt att underlåta leverans',
    blocks: [
      {
        type: 'p',
        text: 'Kunden garanterar att angiven information för tryck eller märke är laglig i varje hänseende, att det inte utgör intrång i annans rättighet samt att den inte innehåller stötande material. C.L. Seifert förbehåller sig rätten att underlåta att leverera en beställning om information eller material enligt ovan inte är förenlig med detta avtals etiska regler enligt denna punkt, eller på annat sätt enligt C.L. Seifert bedömning är oetisk.',
      },
      {
        type: 'p',
        text: 'Våra fastlagda etiska regler gällande innehåll i fotoprodukter och texter som tillhandahålls av C.L. Seifert:',
      },
      {
        type: 'ul',
        items: [
          'Vapen, tillhygge eller annat våldsinslag får inte förekomma på bild eller i text.',
          'Narkotiska preparat, andra droger eller tillhörande attribut får inte förekomma på bild eller i text.',
          'Attribut med rasistisk eller diskriminerande innebörd får inte förekomma på bild eller i text.',
          'Omotiverad nakenhet, obscen text, gest på bild, samt annat som kan upplevas som stötande eller kränkande får inte förekomma på bild.',
        ],
      },
      {
        type: 'p',
        text: 'Vi förbehåller oss rätten att undanta eller ersätta tveksam bild och text från produktion.',
      },
    ],
  },
  {
    title: 'Leverans',
    blocks: [
      {
        type: 'p',
        text: 'Kundens beställning levereras vid den tidpunkt och på det sätt som angivits av C.L Seifert vid beställning. Om inget angivits sker leverans till den skola eller plats varifrån beställningen hör. Om C.L Seifert erbjudit kunden kostnadsfri leverans till skolan men sedermera inte får leverera beställningen till skolan förbehåller sig C.L. Seifert rätten att på efterhand debitera en fraktkostnad för att kunna skicka beställningen till kundens hemadress.',
      },
      {
        type: 'p',
        text: 'C.L. Seifert reserverar sig för eventuell slutförsäljning. C.L. Seifert förbehåller sig dessutom rätten att leverera likvärdig ersättningsvara för det fall en vara utgått ur C.L. Seiferts kollektion.',
      },
    ],
  },
  {
    title: 'Reklamation',
    blocks: [
      {
        type: 'p',
        text: 'För att reklamera en vara ber vi dig att kontakta kundtjänst så fort som ni upptäckt defekten, antingen via telefon 031-3878700 eller e-mail: info@clseifert.se för godkännande och behandling. Varor som per post skickas in till oss utan medföljande eller föregående meddelande om vad du anser är fel med produkten kommer inte att behandlas. Vi bekostar frakten vid reklamationer.',
      },
    ],
  },
  {
    title: 'Fel och felavhjälpning',
    blocks: [
      {
        type: 'p',
        text: 'Med fel avses att tryck eller märke på vara avviker från av kunden godkänt material eller att varan i övrigt är behäftad med brister eller fel. C.L. Seifert ansvarar inte för fel som beror på kunden eller kundens hantering.',
      },
      {
        type: 'p',
        text: 'Kunden ansvarar själv för att varor beställs i rätt storlek, rätt stavning eller antal.',
      },
      {
        type: 'p',
        text: 'C.L. Seifert äger rätt att i första hand på egen bekostnad avhjälpa felet eller företa omleverans om så kan ske inom skälig tid och utan väsentlig olägenhet för kunden.',
      },
    ],
  },
  {
    title: 'Garanti',
    blocks: [
      {
        type: 'p',
        text: 'Vår produktgaranti avser samtliga av våra studentmössor. Garantin avser fabrikationsfel som kan hänföras till tillverkningen av studentmössan. Denna garanti gäller under köparens livstid, dock högst i femtio år från produktionsdagen. Garantin täcker ursprungliga fel på produkten som denna varit behäftad med från produktionen. Förslitningsskador (slitage) eller handhavandefel omfattas ej av denna garanti.',
      },
    ],
  },
  {
    title: 'Personuppgifter',
    blocks: [
      {
        type: 'p',
        text: 'När du ingår avtal med C.L. Seifert kommer vi att behandla uppgifter om ditt namn och dina kontaktuppgifter för att kontakta dig med anledning av din beställning, samt även i övrigt i den mån som krävs för att kunna leverera samt ta betalt för de varor du har köpt av oss. C.L. Seifert förbehåller sig rätten att efter en intresseavvägning använda ditt namn och dina kontaktuppgifter för direktmarknadsföringsändamål under en tid om maximalt ett år från ditt senaste köp. Därefter kommer dina personuppgifter endast att lagras i den utsträckning som krävs för rent bokföringstekniska ändamål samt i övrigt enlig vad som följer av lag. Dina personuppgifter kan komma att lämnas till tredje part för uppfyllande av nu uppräknade syften eller förpliktelser enligt detta avtal. Se mer om dina rättigheter och hur vi behandlar dina personuppgifter i vår personuppgiftspolicy.',
      },
    ],
  },
  {
    title: 'Storleksgaranti',
    blocks: [
      {
        type: 'p',
        text: 'Vår storleksgaranti avser en studentmössa som har beställts i fel storlek av kunden och i de fall där felet ej är till följd av ett produktionsfel. I detta fall står C.L Seifert AB för kostnaden för att justera storleken. Storleksgarantin måste åberopas senast inom 14 dagar från leveranstillfället. Storleksgarantin går enbart att utnyttja vid ett tillfälle. Inga ändringar av tillval och design går att göra vid utnyttjandet av denna garanti.',
      },
    ],
  },
];
